<template>
  <v-row>
    <v-col cols="10">
            <span class="body-1">
              Année d'arrêté
            </span><br>
      <span v-if="selected_dossier.annee_arrete" class="body-2">
              {{ selected_dossier.annee_arrete }}
            </span>

      <span v-else class="body-2">
              Non défini
            </span>
    </v-col>
    <v-col cols="1">
      <v-dialog v-model="dialog" max-width="600">
        <template v-slot:activator="{on, attrs}">
          <v-btn color="primary" icon v-on="on" v-bind="attrs">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-toolbar color="primary">
            <v-toolbar-title class="white--text">Modifier le numéro d'arrêté</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field type="number" label="Année d'arrêté" v-model="anneeArrete"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="updateAnneeArrete">Modifier</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'AnneeArrete',
  props: {
    selected_dossier: {},
  },
  data() {
    return {
      dialog: false,
      anneeArrete: this.selected_dossier.annee_arrete,
    }
  },
  methods: {
    async updateAnneeArrete() {
      let oldValue = this.selected_dossier.annee_arrete;
      let result = await this.$store.dispatch("dossier/patchDossier", {
        id: this.selected_dossier.id,
        annee_arrete: this.anneeArrete
      });
      if (result === "success") {
        this.$store.dispatch("annonce/annonceSuccess", "Année d'arrêté mis à jour.");
        this.dialog = false;
        await this.$store.dispatch("dossier/commentaires/postCommentaire", {
          dossier: this.selected_dossier.id,
          message: `Mise à jour de l'année d'arrêté - ${this.anneeArrete} (Anciennement: ${oldValue})`,
        })
      }
      this.dialog = false;
    }
  }
}
</script>
<style>
.timeline > ol > li:last-child {
  display: none !important;
}
</style>